import { postCriarAfericao } from '../offline/api';

export async function iniciarAfericao(empresa) {
  const empresaId = empresa.id || empresa.Id;

  // Obter localização atual
  const position = await new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(resolve, reject, {
      enableHighAccuracy: true,
      timeout: 10000
    });
  });

  const localizacaoLat = position.coords.latitude;
  const localizacaoLng = position.coords.longitude;

  try {
    const response = await postCriarAfericao({
      empresaId,
      localizacaoLat,
      localizacaoLng
    });
    
    // Retornar o ID da aferição criada
    return response.id;
  } catch (error) {
    console.error('Erro ao criar aferição:', error);
    throw new Error('Erro ao criar aferição. Tente novamente.');
  }
}

